(function() {
	'use strict';

	/**
	 * @TODO move all the hardcoded data into a new read-only CouchDB index.
	 */
	angular
		.module('pwc.data')
		.service('PWCData', PWCData);

	PWCData.$inject = ['$http'];

	function PWCData($http) {

		var Data = {
			fetch: function(which) {

                return $http.get('data/' + which + '.json').then(function(response) {
                    return response.data;
                });
			}
		};

		return Data;

	}

})();